import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import { useTranslation } from "react-i18next";
import { Controller, UseFormMethods } from "react-hook-form";

interface IPostalBox {
    control: UseFormMethods["control"];
    prefix?: string;
}

export const PostalBoxSwitch = (props: IPostalBox) => {
    const { t } = useTranslation(["address"]);
    const { control, prefix } = props;

    const namePrefix = prefix ? `${prefix}.` : "";
    const idPrefix = prefix ? `${prefix}-` : "";

    return (
        <Controller
            control={control}
            name={`${namePrefix}enablePostalBox`}
            render={(renderProps) => (
                <FormControl component="fieldset">
                    <FormGroup aria-label="position" row>
                        <FormControlLabel
                            value={renderProps.value}
                            control={
                                <Switch
                                    checked={renderProps.value}
                                    onChange={(event, val) => {
                                        return renderProps.onChange(val);
                                    }}
                                    id={`${idPrefix}enablePostalBox`}
                                    inputRef={renderProps.ref}
                                    name={renderProps.name}
                                />
                            }
                            label={`${t("address:Use Postal Box?")}`}
                            labelPlacement="end"
                        />
                    </FormGroup>
                </FormControl>
            )}
        />
    );
};
